import React, { KeyboardEvent } from 'react'
import { Product } from '../model'
import Modal from '@material-ui/core/Modal'
import makeStyles from '@material-ui/styles/makeStyles'
import Grid from '@material-ui/core/Grid'
import createStyles from '@material-ui/styles/createStyles'
import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'
import { ChevronLeft, ChevronRight, ZoomIn } from '@material-ui/icons'
import Box from '@material-ui/core/Box'
import SwipeableViews from 'react-swipeable-views'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

const useStyles = makeStyles((theme: any) => createStyles({
    root: {
        width: '100%',
        maxWidth: '100%',
        '& .ProductGalleryModalContent': {
            height: '100%',
            '& .ProductGallerySelectedImageItem': {
                position: 'relative'
            },
            '& .ProductGalleryModalSwipeable': {
                margin: 'auto',
                width: '100%'
            },
            '& .ProductGallerySelectedImage': {
                maxWidth: '100%',
                maxHeight: '100%'
            },
            '& .MuiButton-root .MuiSvgIcon-root': {
                display: 'block',
                margin: 0
            }
        },
        '& .ProductGalleryImageDefaultPreview': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            minWidth: 'initial',
            position: 'absolute',
            right: theme.spacing(2),
            top: theme.spacing(2)
        },
        '& .ProductGalleryModalPreviewsContainer': {
            marginTop: '20px',
            '& .ProductGalleryPreviewImage': {
                maxWidth: 'auto',
                maxHeight: '100px'
            },
            '&:hover': {
                '& .slick-prev, & .slick-next': {
                    opacity: 1,
                    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                }
            },
            '& .slick-slider': {
                overflow: 'hidden'
            },
            '& .slick-prev, & .slick-next': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                height: 'auto',
                minWidth: 0,
                opacity: 0,
                padding: '18px 3px',
                position: 'absolute',
                top: '50%',
                transform: 'translate(0, -50%)',
                transition: 'opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                width: 'auto',
                zIndex: 1,
                '&:before': {
                    content: 'none'
                }
            },
            '& .slick-prev': {
                left: 0
            },
            '& .slick-next': {
                right: 0
            },
            '& .slick-list': {
                margin: '0 -10px'
            },
            '& .slick-slide': {
                boxSizing: 'border-box',
                maxWidth: '33.3333%',
                padding: '0 10px',
            }
        },
        [theme.breakpoints.down('sm')]: {
            '& .ProductGalleryModalPreviewsContainer': {
                '& .slick-prev, & .slick-next': {
                    visibility: 'hidden'
                }
            }
        },
    },
    modal: {
        '& .ProductGalleryModalContent': {
            height: '100%',
            '& .ProductGalleryModalImageItem': {
            },
            '& .ProductGalleryModalSwipeable': {
                margin: 'auto',
                width: '100%'
            },
            '& .ProductGalleryModalImage': {
                maxWidth: '100%',
                maxHeight: '100%'
            }
        },
        '& .ProductGalleryModalPreviewsContainer': {
            height: '25%',
            margin: 'auto'
        },
        '& .ProductGalleryModalImage': {
            maxWidth: '80%',
            maxHeight: '100%',
            margin: 'auto'
        }
    }
}), { name: 'ProductGallery' })

const SliderPrevArrow = props => {
    const { currentSlide, slideCount, ...remainingProps } = props
    return (
        <Button color='primary' {...remainingProps}>
            <ChevronLeft />
        </Button>
    )
}

const SliderNextArrow = props => {
    const { currentSlide, slideCount, ...remainingProps } = props
    return (
        <Button color='primary' {...remainingProps}>
            <ChevronRight />
        </Button>
    )
}

const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToScroll: 3,
    prevArrow: <SliderPrevArrow />,
    nextArrow: <SliderNextArrow />
}

export function ProductGalleryView(props: { product: Product }) {
    const classes = useStyles(props)
    const [modalOpen, setModalOpen] = React.useState(false)
    const [imageIndex, setImageIndex] = React.useState(0)
    const [modalImageIndex, setModalImageIndex] = React.useState(0)
    const productImagesLength = props.product.images.length
    const modalOnKeyDown = (e: KeyboardEvent) => {
        if (e.keyCode === 37) 
            setModalImageIndex(Math.max(modalImageIndex - 1, 0))
        else if (e.keyCode === 39) 
            setModalImageIndex(Math.min(modalImageIndex + 1, productImagesLength - 1))
    }

    return <div className={classes.root}>
        <Grid container direction='column' wrap='nowrap' className='ProductGalleryModalContent'>
            <Grid item className='ProductGallerySelectedImageItem'>
                <SwipeableViews index={imageIndex} className='ProductGalleryModalSwipeable'>
                    {props.product.images.map((image, index) => <Box key={index} display='flex' justifyContent='center' height='435px'>
                        <img src={image.src}
                            alt={image.alt}
                            onClick={() => { setModalOpen(true); setModalImageIndex(imageIndex); }}
                            className='ProductGallerySelectedImage' />
                    </Box>)}
                </SwipeableViews>
                <Button color='primary' onClick={() => { setModalOpen(true); setModalImageIndex(imageIndex); }} className='ProductGalleryImageDefaultPreview'><ZoomIn /></Button>
            </Grid>
            <Grid item className='ProductGalleryModalPreviewsContainer'>
                <Slider slidesToShow={productImagesLength > 3 ? 3 : productImagesLength} {...sliderSettings}>
                    {props.product.images.map((image, index) => <div key={index} onClick={() => setImageIndex(index)}>
                        <img src={image.src}
                            alt={image.alt}
                            className='ProductGalleryPreviewImage' />
                    </div>)}
                </Slider>
            </Grid>
        </Grid>

        <Modal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            className={classes.modal}
            onKeyDown={modalOnKeyDown}
        >
            <Box height='100%' width='100%'>
                {props.product.images.filter((_, index) => index === modalImageIndex).map((image, index) =>
                    <Box key={index} height='100%' width='100%' display='flex' alignItems='center'>
                        <Fab 
                            size="small" 
                            color="primary" 
                            aria-label="Previous" 
                            onClick={() => setModalImageIndex(Math.max(modalImageIndex - 1, 0))} 
                            disabled={modalImageIndex === 0} 
                            style={{minWidth: '40px'}}>
                            <ChevronLeft />
                        </Fab>
                        <img
                            src={image.src}
                            alt={image.alt}
                            onClick={() => setModalOpen(false)}
                            className='ProductGalleryModalImage' />
                        <Fab 
                            size="small" 
                            color="primary" 
                            aria-label="Previous" 
                            onClick={() => setModalImageIndex(Math.min(modalImageIndex + 1, productImagesLength - 1))} 
                            disabled={modalImageIndex >= productImagesLength - 1} 
                            style={{minWidth: '40px'}}>
                            <ChevronRight />
                        </Fab>
                    </Box>
                )}
            </Box>
        </Modal>
    </div>
}
